export interface InputOptions {
    [key: string]: any;
    placeholder?: string;
    isPassword?: boolean;
    minLength?: number | undefined;
    maxLength?: number | undefined;
}

export const InputDefaultOptions: InputOptions = {
    placeholder: '',
    isPassword: false,
    minLength: undefined,
    maxLength: undefined
};

export const TextareaDefaultOptions = {
    editType: 'default', // 'dialog'
    dialogWidth: 400,
    dialogHeight: 300,
    enableWordCount: false,
    countType: 'length',
    onlyShowInDialog: true
};

export interface InputGroupOptions extends InputOptions {
    showClear: true;
    groupText: string;
    disabled: boolean;
    readonly: boolean;
    editable: boolean;
    enableViewPassword?: boolean;
    textAlign?: string;
}


export const InputGroupDefaultOptions: InputGroupOptions = {
    showClear: true,
    groupText: '',
    disabled: false,
    readonly: false,
    editable: true,
    isPassword: false,
    enableViewPassword: true,
    textAlign: 'left',
    minLength: undefined,
    maxLength: undefined
};
export interface ComboListOptions extends InputOptions {
    disabled?: boolean;
    readonly?: boolean;
    editable?: boolean;
    panelWidth?: number;
    panelHeight?: number | string;
    data?: any;
    idField: string;
    valueField: string;
    textField: string;
    uri?: string;
    multiSelect?: boolean;
    selectedValues?: string;
    autoWidth?: boolean;
    enableCancelSelected: boolean;
    enableClear?: true;
    itemTemplate?: any;
    nosearch?: boolean;
    showDisabledItem?: boolean;
    disabledField?: string;
}

export const ComboListDefaultOptions: ComboListOptions = {
    disabled: false,
    readonly: false,
    editable: true,
    placeholder: '请选择',
    panelWidth: 300,
    panelHeight: 'auto',
    autoWidth: true,
    data: [],
    idField: 'id',
    multiSelect: false,
    uri: '',
    textField: '',
    valueField: '',
    enableCancelSelected: true,
    enableClear: true,
    itemTemplate: null,
    nosearch: false,
    showDisabledItem: true,
    disabledField: 'disabled' 
};

export const EnumEditorDefaultOptions = {
    outType: 0,
    readonly: false,
    editable: false,
    disabled: false,
    enableClear: true,
    textField: 'name',
    valueField: 'value'
};
